import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";
import {FRUtilities} from "#Formulas/FormulaCore/Utilities/FRUtilities";


export class FRFor extends FRBase{

    private Var:FRBase;
    private Cond:FRBase;
    private Inc:FRBase;
    private Statement:FRBase;
    public ShouldBreak:boolean=false;
    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);

        this.Var=FRFactory.GetFRElement(Options.V,this);
        if(Options.C!=null)
            this.Cond=FRFactory.GetFRElement(Options.C,this);

        if(Options.I!=null)
            this.Inc=FRFactory.GetFRElement(Options.I,this);

        this.Statement=FRFactory.GetFRElement(Options.S,this);
    }

    Parse(): any {
        this.ShouldBreak=false;


        return this.MaybeExecutePromise(this.Var.Parse(),()=>{
           let result=null;
           let lastResult=null;
           if(this.Cond==null)
               return result;
           let iterator=()=>{
               return this.MaybeExecutePromise(this.Cond.Parse(),condResult=>{
                   if(!condResult)
                       return result;

                   return this.MaybeExecutePromise(this.Statement.Parse(),statementResult=>{
                       result=statementResult;
                       if(this.ShouldBreak)
                           return result;

                       if(this.Inc!=null)
                           return this.MaybeExecutePromise(this.Inc.Parse(),()=>{
                               return iterator();
                           });
                       else
                           return iterator();
                   });

               })
           };

           return iterator();

        });

    }


    public ReturnWasExecuted(){
        this.ShouldBreak=true;
        FRUtilities.NotifyReturnToParent(this);
    }

    public BreakWasExecuted(){
        this.ShouldBreak=true;
    }


}

FRFactory.AddField('FOR',FRFor);